import axios from 'axios';
import { configRefs } from '@utils/constants';

async function deleteTeamRequest(team) {
  await axios.delete(`${await configRefs.apis.userdata.get()}/api/Filters/${team.id}`);
}

export { deleteTeamRequest };
//# sourceMappingURL=api.delete-team.request.js.map
